import { useContext, useEffect } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { Colour } from "../Variables";
import { AppContext } from "../../contexts/AppContext";
import { JobAlertsForm } from "../components/Forms/JobAlertsForm";

export function JobAlerts() {
    const app = useContext(AppContext);
    const routeContext = useContext(RouteContext);
    
    useEffect(() => {
        routeContext.setRoutes([{ name: "Job alerts", route: null }])
    }, []);

    return (
        <>
            <InfoBanner
                header="Job alert subscription"
                icon={InfoHeaderIcon.YourApplications}
                info={`Use this section to select the ${app.positions?.Features?.DisplayText_Department?.toLocaleLowerCase() ?? "departments"} and locations that you would like to hear about in job alert emails. Once you have made your selection, please click 'Save' at the bottom of the page. You can update your preferences at any time.`}
                narrow={false}
                subHeader={`${app.firmName} online application system`}
                theme={Colour.Primary}>
            </InfoBanner>

            <JobAlertsForm />
        </>
    );
}